import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { Tabs, TabPanel } from '@tencent/spaui-tabs'
import AppList from './biz-components/AppList'
import ProgressManagement from './biz-components/ProgressManagement'
import TopNav from 'biz-components/TopNav'
import { useUploadQueue } from 'hooks/useUploadQueue'
import { useLayoutTabs } from 'hooks/useLayoutTabs'
import MtaH5 from 'mta-h5-analysis'
import 'styles/index.css'
import './utils/monitor'

const Layout = () => {
    const { activeTab, handleTabChange } = useLayoutTabs()
    const { progress } = useUploadQueue()

    useEffect(() => {
        // 因为progress是全局变量，引用不会发生改变，useEffect内容只会在didMount时执行
        const windowUnloadHandler = event => {
            // 判断有上传中的数据才会提示
            if (progress && Object.keys(progress).length > 0) {
                // Cancel the event as stated by the standard.
                event.preventDefault()
                // Chrome requires returnValue to be set.
                // 新版本的浏览器文案设置无效
                event.returnValue = '关闭当前页面会导致“上传管理中心”的渠道包上传失败，确认关闭当前页面？'
            }
        }

        window.addEventListener('beforeunload', windowUnloadHandler)

        return () => {
            window.removeEventListener('beforeunload', windowUnloadHandler)
        }
    }, [progress])

    return (
        <div className="page-container embed">
            <TopNav />
            <div className="main main-full">
                <div className="content">
                    {/* <BreadCrumb text="广告渠道包管理" /> */}
                    <div className="sec-tabs" id="tabs">
                        <Tabs onChange={handleTabChange} value={activeTab} className="datalist-tabs">
                            <TabPanel tab="主线包管理" name="0">
                                <div className="spaui-tabs-content">
                                    <AppList />
                                </div>
                            </TabPanel>
                            <TabPanel tab="上传管理中心" name="1">
                                <div className="spaui-tabs-content">
                                    <ProgressManagement />
                                </div>
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    )
}

ReactDOM.render(<Layout />, document.getElementById('root'))

// eslint-disable-next-line no-undef
window.VERSION = VERSION

// MtaH5上报初始化
MtaH5.init({
    sid: 500699045, //必填，统计用的appid
    cid: 500699047, //如果开启自定义事件，此项目为必填，否则不填
    autoReport: 1, //是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
    senseHash: 0, //hash锚点是否进入url统计
    senseQuery: 0, //url参数是否进入url统计
    performanceMonitor: 0, //是否开启性能监控
    ignoreParams: [], //开启url参数上报时，可忽略部分参数拼接上报
})
